<template>
  <div class="text-base">
    <PageHeader />
    <main>
      <slot />
    </main>
    <PageFooter />
    <NavigationSecondary />
  </div>
</template>

<script setup lang="ts">
// Fetch site config, needs to be preloaded fore use in header and footer
await useConfigStore().fetchConfig()
</script>
